module.exports = __webpack_public_path__ + "img/create-order.6875ed77.gif";